import { useState, useCallback } from "react";
import { language, setLanguage } from "@icarius-localization/strings";

const useChangeLanguage = () => {

  const [, setLocalLanguage] = useState(language); // se usa solo para forzar render en el login y que se  ejecuten los getLocalizedString de nuevo con el nuevo lenguaje

  const handleChangeLanguage = useCallback((newLang) => {
    setLanguage(
      newLang,
      () => setLocalLanguage(newLang)
    );
  }, []);

  return handleChangeLanguage;
}

export default useChangeLanguage;
